<!-- Preview Mode -->
<div *ngIf="mode === 'preview'" [ngStyle]="getPreviewStyles()" class="p-6 rounded-lg">
  <!-- Heading -->
  <div *ngIf="getHeading()" [ngClass]="getTitlePositionClass()" class="mb-4">
    <h3 class="text-xl font-bold" [style.color]="getHeadingColor()">{{ getHeading() }}</h3>
    <p *ngIf="getSubtitle()" class="text-sm mt-1 opacity-70" [style.color]="getTextColor()">{{ getSubtitle() }}</p>
  </div>

  <!-- Map Placeholder -->
  <div
    class="relative overflow-hidden bg-gray-200 flex items-center justify-center"
    [style.height]="getMapHeight() + getMapHeightUnit()"
    [style.border-radius]="getBorderRadius() + 'px'"
  >
    <!-- Static map placeholder with grid pattern -->
    <div class="absolute inset-0 opacity-30" style="
      background-image:
        linear-gradient(rgba(0,0,0,0.1) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0,0,0,0.1) 1px, transparent 1px);
      background-size: 40px 40px;
    "></div>

    <div class="relative flex flex-col items-center text-gray-500">
      <!-- Map Pin Icon -->
      <svg class="w-12 h-12 mb-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
      </svg>
      <p class="text-sm font-medium">OpenStreetMap</p>
      <p class="text-xs mt-1">{{ getLat().toFixed(4) }}, {{ getLng().toFixed(4) }} &middot; Zoom {{ getZoom() }}</p>
      <p *ngIf="getMarkers().length > 0" class="text-xs mt-0.5">{{ getMarkers().length }} marker{{ getMarkers().length !== 1 ? 's' : '' }}</p>
    </div>
  </div>
</div>
